import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'

import {
  FaCalendarDay,
  FaCalendarAlt,
  FaCalendarCheck,
  FaMoneyBillWave,
  FaCreditCard,
  FaSyncAlt,
  FaFileExcel,
} from 'react-icons/fa'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js'
import Cookies from 'js-cookie'
import axios from 'axios'
import * as XLSX from 'xlsx'
import { useAuth } from './AuthContext'
import moment from 'moment'
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

export default function FeeCollection() {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const { user } = useAuth()
  console.log('USER AUTH', user)
  const [data, setData] = useState([])
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [dataByDate, setDataByDate] = useState([])
  const [noDataMessage, setNoDataMessage] = useState('')
  const [paymentFilter, setPaymentFilter] = useState('all')
  const [allFromData, setAllFromData] = useState('')

  const [title, setTitle] = useState(
    `Today's Collection (${moment().format('DD/MM/YYYY')})`,
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        const instituteId = Cookies.get('institute_id')
        console.log('INSTITUTE ID: ', instituteId)
        const headers = {
          Authorization: `Bearer ${user.token}`,
          institute_id: instituteId,
        }
        console.log('HEADERS: ', headers)
        const response = await axios.get(
          BASE_URL+'/fee-collection',
          { headers },
        )
        console.log('Response of data: ', response)
        setData(response.data.data)
      } catch (error) {
        console.log(error.response?.data?.message)
      }
    }
    fetchData()
  }, [])

  const fetchDatabyDate = async (from = '', to = '', paymentMethod = 'all') => {
    try {
      const instituteId = Cookies.get('institute_id')
      const headers = {
        Authorization: `Bearer ${user.token}`,
        institute_id: instituteId,
      }

      const params = new URLSearchParams()
      if (from) params.append('from_date', from)
      if (to) params.append('to_date', to)
      if (paymentMethod && paymentMethod !== 'all') {
        params.append('payment_method', paymentMethod)
      }

      let url =
        BASE_URL+'/get/fee-collection/by-date'
      if (params.toString()) url += '?' + params.toString()

      const response = await axios.get(url, { headers })
      console.log('RESPONSE during selected fees:', response.data.data)
      setDataByDate(response.data.data)
    } catch (error) {
      console.log(error.response?.data?.message)
      setDataByDate([])
      setNoDataMessage(error.response?.data?.message)
    }
  }

  useEffect(() => {
    fetchDatabyDate()
  }, [])

  const handleDateChange = (type, value) => {
    console.log('Change triggered:', { type, value })
    if (type === 'from') {
      console.log('From date is set: ', value)
      setFromDate(value)
    } else {
      setToDate(value)
      console.log('To date is set:', value)
    }

    const newFrom = type === 'from' ? value : fromDate
    const newTo = type === 'to' ? value : toDate

    console.log('Evaluted dates:', { newFrom, toDate })

    if (newFrom && newTo) {
      const displayTitle =
        newFrom === newTo
          ? `${moment(newFrom).format('D MMM YYYY')} Collection`
          : `${moment(newFrom).format('D MMM YYYY')} - ${moment(newTo).format(
              'D MMM YYYY',
            )} Collection`

      console.log('Tittle (both dates):', displayTitle)
      setTitle(displayTitle)
      fetchDatabyDate(newFrom, newTo, paymentFilter)
    }
    // else if (newFrom) {
    //   const title = `${moment(newFrom).format('D MMM YYYY')} Collection`
    //   console.log('Title (from date only):', title)
    //   setTitle(title)
    //   fetchDatabyDate(newFrom, '', paymentFilter)
    // } else if (newTo) {
    //   setTitle(`Upto ${moment(newTo).format('D MMM YYYY')} Collection`)
    //   fetchDatabyDate('', newTo, paymentFilter)
    // }
  }

  useEffect(() => {
    fetchDatabyDate(fromDate, toDate, paymentFilter)
  }, [paymentFilter])

  const handleFromDateChange = (type, value) => {
    if (type === 'from') {
      setFromDate(value)

      if (value) {
        const title = `${moment(value).format('D MMM YYYY')} Collection`
        console.log('Title (from date only):', title)
        setTitle(title)

        // Call API with selected_date as query param
        fetchFromDate(value, paymentFilter)
      }
    }
  }

  const fetchFromDate = async (from = '', paymentMethod = 'all') => {
    try {
      const instituteId = Cookies.get('institute_id')
      const headers = {
        Authorization: `Bearer ${user.token}`,
        institute_id: instituteId,
      }

      const params = new URLSearchParams()
      if (from) params.append('selected_date', from)
      if (paymentMethod && paymentMethod !== 'all') {
        params.append('payment_method', paymentMethod)
      }

      let url =
        BASE_URL+'/get/fee-collection/by-date'
      if (params.toString()) url += '?' + params.toString()

      console.log('Request URL:', url) // ✅ Check the correct URL

      const response = await axios.get(url, { headers })
      setDataByDate(response.data.data)
      setNoDataMessage('')
    } catch (error) {
      setDataByDate([])
      setNoDataMessage(error.response?.data?.message || 'No data found')
    }
  }

  useEffect(() => {
    fetchFromDate(fromDate)
  }, [])

  const handleRefresh = () => {
    setFromDate('')
    setToDate('')
    setPaymentFilter('all')
    setTitle(`Today's Collection (${moment().format('DD/MM/YYYY')})`)
    fetchDatabyDate() // fetch data with default values
  }

  const exportToExcel = () => {
    const exportData = dataByDate.map((data) => {
      const receiptNo = `${new Date(
        data.transaction_date,
      ).getFullYear()}${String(
        new Date(data.transaction_date).getMonth() + 1,
      ).padStart(2, '0')}${data.id.toString(16).toUpperCase()}`

      return {
        'Fees Receipt No.': receiptNo,
        'Admission Number': data.admission_number,
        Name: data.student_name,
        'Fees Name': data.fees_name,
        'Transaction Amount': data.transaction_amount,
        'Transaction Date': data.transaction_date,
        'Payment Method': data.payment_method,
        'Transaction Number': data.transaction_id || '',
      }
    })

    const worksheet = XLSX.utils.json_to_sheet(exportData)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Transactions')

    XLSX.writeFile(workbook, 'Transaction_Records.xlsx')
  }
  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2>💰 Fees Collection</h2>
        </div>

        <div className=" mt-4">
          <Row className="mt-3">
            <Col md={4} className="mb-3">
              <Card className="text-center shadow-sm border-0">
                <Card.Body>
                  <FaCalendarDay size={40} className="text-primary mb-2" />
                  <Card.Title>Today Fee Collection</Card.Title>
                  <Card.Text>₹ {data.today_collection}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-3">
              <Card className="text-center shadow-sm border-0">
                <Card.Body>
                  <FaCalendarAlt size={40} className="text-success mb-2" />
                  <Card.Title>Monthly Fee Collection</Card.Title>
                  <Card.Text>₹ {data.monthly_collection}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-3">
              <Card className="text-center shadow-sm border-0">
                <Card.Body>
                  <FaCalendarCheck size={40} className="text-warning mb-2" />
                  <Card.Title>Yearly Fee Collection</Card.Title>
                  <Card.Text>₹ {data.yearly_collection}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={4} className="mb-3">
              <Card className="text-center border-0 shadow-sm">
                <Card.Body>
                  <FaMoneyBillWave size={40} className="text-danger mb-2" />
                  <Card.Title>Buy Cash</Card.Title>
                  <Card.Text>₹ {data.by_cash}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-3">
              <Card className="text-center border-0 shadow-sm">
                <Card.Body>
                  <FaCreditCard size={40} className="text-info mb-2" />
                  <Card.Title>Buy Online</Card.Title>
                  <Card.Text>₹ {data.by_online}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <hr
            className="shadow my-3"
            style={{
              border: 'none',
              borderTop: '2px solid gray',
              height: '2px',
              opacity: 1,
            }}
          />

          <Row className="g-2 align-items-end d-flex mt-3 flex-wrap">
            <Col
              md={3}
              className="fw-bold text-primary text-start"
              style={{ fontSize: '20px' }}
            >
              {title}
            </Col>

            <Col md={2} className="fw-bold text-start">
              <Form.Label className="mb-0">Filter by Payment Method</Form.Label>
              <Form.Control
                as="select"
                value={paymentFilter}
                onChange={(e) => setPaymentFilter(e.target.value)}
                className="form-select-sm"
              >
                <option value="all">All</option>
                <option value="online">Online</option>
                <option value="cash">Cash</option>
                <option value="cheque">Cheque</option>
              </Form.Control>
            </Col>

            <Col md={2} className="text-start">
              <Form.Label className="fw-bold mb-0">From</Form.Label>
              <Form.Control
                size="sm"
                type="date"
                value={fromDate}
                onChange={(e) => handleFromDateChange('from', e.target.value)}
                // onChange={(e) => handleDateChange('from', e.target.value)}
              />
            </Col>

            <Col md={2} className="text-start">
              <Form.Label className="fw-bold mb-0">To</Form.Label>
              <Form.Control
                size="sm"
                type="date"
                value={toDate}
                onChange={(e) => handleDateChange('to', e.target.value)}
              />
            </Col>
            {/* <Col className="d-flex justify-content-md-start justify-content-start"> */}
            <Col className="d-none d-md-flex justify-content-md-center justify-content-start d-inline">
              <Button
                variant="outline-primary"
                onClick={handleRefresh}
                title="Refresh"
              >
                <FaSyncAlt />
              </Button>
            </Col>
            {dataByDate.length > 0 && (
              <Col md={2} className="d-none d-md-flex">
                <Button variant="outline-success" onClick={exportToExcel}>
                  <FaFileExcel /> Export to Excel
                </Button>
              </Col>
            )}
          </Row>
          <div className="d-block d-md-none mt-3 justify-content-start d-flex">
            <Button
              variant="outline-primary"
              onClick={handleRefresh}
              className="me-2 mb-2"
            >
              <FaSyncAlt /> Refresh
            </Button>

            {dataByDate.length > 0 && (
              <Button
                variant="outline-success"
                onClick={exportToExcel}
                className="mb-2"
              >
                <FaFileExcel /> Export to Excel
              </Button>
            )}
          </div>
          <Table className="table table-striped table-bordered table-hover rounded shadow-sm mb-5 mt-5">
            <Thead className="bg-dark text-white">
              <Tr className=" rounded mb-4">
                <Th>Fees Receipt No.</Th>
                <Th>Admission Number</Th>
                <Th>Student Name</Th>
                <Th>Fees Name</Th>
                <Th>Transaction Amount</Th>
                <Th>Discount</Th>
                <Th>Transaction Date</Th>
                <Th>Payment Method</Th>
                <Th>Transaction Number</Th>
                <Th>Fees Taken By</Th>
              </Tr>
            </Thead>
            <Tbody className="mb-5 mt-3">
              {dataByDate.length > 0 ? (
                dataByDate
                  .filter(
                    (item) =>
                      paymentFilter === 'all' ||
                      (item.payment_method &&
                        item.payment_method.toLowerCase() === paymentFilter),
                  )

                  .map((item, index) => (
                    <Tr key={index} className="align-middle ">
                      <Td>
                        {`${new Date(
                          item.transaction_date,
                        ).getFullYear()}${String(
                          new Date(item.transaction_date).getMonth() + 1,
                        ).padStart(2, '0')}${item.id
                          .toString(16)
                          .toUpperCase()}`}
                      </Td>
                      <Td>{item.admission_number}</Td>
                      <Td>{item.student_name}</Td>
                      <Td>{item.fees_name}</Td>
                      <Td>{item.transaction_amount ? `₹ ${item.transaction_amount}`:""}</Td>
                      <Td>{item.discount ? `₹ ${item.discount}`:""}</Td>
                      <Td>
                        {new Date(item.transaction_date).toLocaleDateString(
                          'en-GB',
                          {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                          },
                        )}
                      </Td>

                      <Td>
                        {item.payment_method?.toUpperCase() || 'Not Selected'}
                      </Td>
                      <Td className="text-break py-4 mb-2">
                        {item.transaction_id}
                      </Td>
                      <Td>{item.taken_by_name || "-"}</Td>
                    </Tr>
                  ))
              ) : (
                <Tr>
                  <Td
                    colSpan="9"
                    className="text-center text-danger fw-bold p-4"
                  >
                    {noDataMessage}
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </div>
      </div>
    </div>
  )
}
